export interface Transaction{
  createdAt?: Date,
  updatedAt?: Date,
  transactionId?: number,
  status?: string,
  type?: string,
  paymentDate?: Date,
  amount?: number,
  fawryTransactions: fawryTransactions[],
  sapTransactions: sapTransactions[],
  deglawyPointsTransactions: DeglawyPointsTransaction[],
  paymobTransactions: PaymobTransaction[],
  waterFrontTransaction?: {
    id: number,
    confirmationId: string | number| null,
  },
}
export interface fawryTransactions{
    "createdAt":Date,
    "updatedAt":Date,
    "incrementId":number,
    "fawryOrderId":string,
    "status":string,
    "amount":number
}

export interface PaymobTransaction{
  createdAt: Date,
  incrementId: number,
  paymobTransactionId: string,
  status: string,
}

export interface sapTransactions{
    "createdAt": Date,
    "updatedAt": Date,
    "documentCode": string,
    "documentCategoryCode": string,
    "documentCodeOData": string,
    "documentCategoryName": string,
    "amount": number,
    "documentCompanyCode": string,
    "documentDueDate": Date,
    "isSapNotified": boolean
    sapTransactionLogs: SapTransactionLogs [];
}
export interface SapTransactionLogs {
    sapTransactionLogId: string;
    transactionId: string;
    response: string;
    createdAt: Date | string,
    updatedAt: Date |string,
    responseError?: string;
}

export enum TransactionStatus {
    ALL = "all",
    REGISTERED = "registered",
    INITIATED = "initiated",
    PROCCESSING = "processing",
    SUCCEEDED = "succeeded",
    FAILED = "failed",
    PENDING = "pending",
    CANCELED = "canceled"
}
export enum SapTransactionStatus {
    ALL = "all",
    TRUE = "true",
    FALSE = "false"
}

export enum ConfirmationStatus {
  All = 'all',
  Confirmed = 'true',
  UnConfirmed = 'false',
}

export enum PaymentType {
  ALL = 'all',
  FAWRY = 'fawry',
  POINTS = 'points',
  PAYMOB = 'paymob',
}

export enum TransactionDue {
  Renewal = 'renewal',
  SRS = 'srs',
  Waterfront = 'waterfront',
}

export interface TransactionFilterOptions {
  pageNumber: number,
  totalNumberOfPages: number,
  pageSize: number,
  start: number | Date | string,
  end: number | Date | string,
  filterValue: string,
  status: TransactionStatus | '', // empty string for no filtering
  paymentType: PaymentType | '', // empty string for no filtering
  isSapNotified?: SapTransactionStatus | '', // empty string for no filtering
  isConfirmed?: ConfirmationStatus | '', // empty string for no filtering
  payableFor: TransactionDue,
}

export interface DeglawyPointsTransaction {
    "createdAt":Date,
    "updatedAt":Date,
    "id":number,
    "dsquaresTransactionId":string,
    "status":string,
    "amount":number
}